export interface MeshGeometry {
  readonly positions: Float32Array;
  readonly normals: Float32Array;
  readonly indices: Uint16Array;
  readonly texcoords?: Float32Array;
  /** Eight normalized bytes: seven terrain weights plus one reserved channel. */
  readonly surfaceWeights?: Uint8Array;
  /** Editor-only premultiplied RGB tint and coverage; absent from gameplay meshes. */
  readonly editorBiomeTint?: Uint8Array;
}

export function createDebugMarker(segments = 12): MeshGeometry {
  const positions: number[] = [];
  const normals: number[] = [];
  const indices: number[] = [];
  const radius = 0.22;
  const height = 0.95;

  for (let segment = 0; segment <= segments; segment += 1) {
    const angle = (segment / segments) * Math.PI * 2;
    const x = Math.sin(angle) * radius;
    const z = Math.cos(angle) * radius;
    positions.push(x, 0, z, x, height, z);
    normals.push(x / radius, 0, z / radius, x / radius, 0, z / radius);
    if (segment < segments) {
      const offset = segment * 2;
      indices.push(offset, offset + 1, offset + 3, offset, offset + 3, offset + 2);
    }
  }

  const topCenter = positions.length / 3;
  positions.push(0, height, 0, 0, 0, 0);
  normals.push(0, 1, 0, 0, -1, 0);
  for (let segment = 0; segment < segments; segment += 1) {
    indices.push(topCenter, segment * 2 + 1, (segment + 1) * 2 + 1);
    indices.push(topCenter + 1, (segment + 1) * 2, segment * 2);
  }

  return {
    positions: new Float32Array(positions),
    normals: new Float32Array(normals),
    indices: new Uint16Array(indices),
  };
}
